module.exports = __webpack_public_path__ + "img/foregin.a68c9b04.png";